import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';

const COMPONENT = 'features:auth.components.company_website_input' satisfies I18nPrefix;

type CompanyWebsiteInputProps = {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
};

function trimProtocol(url: string) {
  return url.replace(/^https?:\/\//, '');
}

export function CompanyWebsiteInput({
  value,
  onChange,
  required,
  placeholder = ' ',
}: CompanyWebsiteInputProps) {
  return (
    <div className="relative mt-2 flex">
      <span className="inline-flex items-center rounded-l-md border border-gray-300 border-r-0 bg-gray-50 px-3 text-gray-500 sm:text-sm">
        https://
      </span>
      <input
        id="company-website"
        name="company-website"
        value={value}
        placeholder={placeholder}
        required={required}
        className="peer block w-full appearance-none rounded-none rounded-r-md border border-gray-300 px-3 pt-3 pb-2 placeholder-gray-400 shadow-xs focus:border-indigo-500 focus:outline-hidden focus:ring-indigo-500 sm:text-sm"
        onChange={(event) => onChange(trimProtocol(event.target.value))}
        onPaste={(event) => {
          event.preventDefault();
          onChange(trimProtocol(event.clipboardData.getData('text')));
        }}
      />
      <label
        htmlFor="company-website"
        className="absolute inset-s-18.75 top-2 z-10 ml-2 flex origin-left -translate-y-4 transform items-center gap-x-1 bg-white px-2 text-gray-400 text-sm duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:px-2 peer-focus:text-indigo-600"
      >
        {t(`${COMPONENT}.label`)}
      </label>
    </div>
  );
}
